<template>
  <div class="package-price-setting">
    <a-card title="预约设置" :bordered="false">
      <a-tabs style="background-color: white;" default-active-key="2" @tabClick="onTabClick">
        <a-tab-pane tab="预约信息" key="1"></a-tab-pane>
        <a-tab-pane tab="预约套餐" key="2"></a-tab-pane>
      </a-tabs>
      <span>套餐名称：{{ optionName }}</span>
      <a-row :span="24">
        <a-col :span="18" style="position: relative">
          <a-calendar :mode="mode" @panelChange="onPanelChange" @select="onDateSelected">
            <div style="width: 100%;" slot="dateCellRender" slot-scope="value">
              <a-checkbox v-if="!isDisabledDate(value)" class="item-checkbox" :checked="isSelected(value)"
                          style="width: 40px"></a-checkbox>
              <div v-for="item in getListData(value)" :key="item.content" style="font-size: 12px">{{ item.content }}
              </div>
            </div>
          </a-calendar>
          <a-checkbox v-model="selectedAll" style="position: absolute;right: 320px;top: 16px" @change="selectedAllDate">
            全选
          </a-checkbox>
        </a-col>
        <a-col :span="6">
          <a-form-model ref="form" :label-col="{span:12}" :wrapper-col="{span:12}" :model="priceForm"
                        :rules="priceRules">
            <a-form-model-item label="每张可兑" :colon="true">
              <a-input :disabled="true" v-model="priceForm.redeemCount">
                <span slot="addonAfter">份</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="日历模式">
              <a-radio-group v-model="priceForm.priceMode" :disabled="true">
                <a-radio :value="1">标准日历</a-radio>
                <a-radio :value="2">酒店日历</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="补差方式">
              <a-radio-group :disabled="true" v-model="priceForm.addAmountWay">
                <a-radio :value="1">在线补差</a-radio>
                <a-radio :value="2">线下补差</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="差价" prop="bespeakPrice">
              <a-input v-model="priceForm.bespeakPrice" placeholder="请输入差价"></a-input>
            </a-form-model-item>
            <a-form-model-item label="差价成本" prop="gapPrice">
              <a-input v-model="priceForm.gapPrice" placeholder="请输入差价成本"></a-input>
            </a-form-model-item>
            <a-form-model-item label="库存" prop="stockNum">
              <a-input v-model="priceForm.stockNum" placeholder="请输入库存"></a-input>
            </a-form-model-item>
            <a-form-model-item label="预警" prop="warnNum">
              <a-input v-model="priceForm.warnNum" placeholder="请输预警值"></a-input>
            </a-form-model-item>
            <a-form-model-item label="是否需要二次确认">
              <a-select v-model="priceForm.isConfirm" placeholder="请选择">
                <a-select-option :value="0">不需要</a-select-option>
                <a-select-option :value="1">需要</a-select-option>
              </a-select>
            </a-form-model-item>
            <div style="text-align: center">
              <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
              <a-popconfirm v-if="selectedDateList && selectedDateList.length>0" style="margin-left: 20px"
                            title="是否要删除当前价格？" @confirm="deleteEvent()">
                <a-button type="danger" :loading="submitLoading">删除</a-button>
              </a-popconfirm>
              <a-button @click="onTabClick(2)" style="margin-left: 20px">取消</a-button>
            </div>
          </a-form-model>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import formMixin from '@/utils/mixins/formMixins'

export default {
  name: 'PackagePriceSetting',
  mixins: [formMixin],
  data() {
    return {
      optionName: '',
      mode: 'month',
      selectedAll: false,
      couponType: '',
      priceForm: {
        addAmountWay: 0,
        priceMode: 1,
        redeemCount: 0,
        bespeakPrice: '',//预约价格
        gapPrice: '',
        stockNum: '',
        warnNum: '',
        isConfirm: 0// 0:不需要二次确认,1:需要二次确认
      },
      priceRules: {
        bespeakPrice: [
          { required: true, message: '请输入差价', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: this.checkMaxPrice, trigger: 'blur' }
        ],
        gapPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: this.checkMaxPrice, trigger: 'blur' }
        ],
        stockNum: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
        ],
        warnNum: [
          { required: true, message: '请输入预警值', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的预警值', trigger: 'blur' }
        ]
      },
      priceDataList: [],
      selectedDateList: [],
      monthStr: ''
    }
  },
  mounted() {
    let pageParams = this.getPageParams()
    this.monthStr = this.getDateHelper().getCurrentFormatDate('YYYY-MM')
    this.optionName = pageParams.optionName
    this.optionId = pageParams.optionId
    this.proId = pageParams.proId
    this.couponType = pageParams.couponType
    this.getMonthPriceInfo()
  },
  watch: {
    selectedDateList: function(dateList) {
      if (dateList && dateList.length > 0) {
        //自动填充选中的第一个日期的价格
        const firstDate = dateList[0]
        let selectedPriceItem = this.priceDataList.find((item, index, arr) => item.bespeakPriceDate === firstDate)
        if (selectedPriceItem) {
          this.priceForm = {
            ...this.priceForm,
            bespeakPrice: selectedPriceItem.bespeakPrice,
            stockNum: selectedPriceItem.stockNum,
            warnNum: selectedPriceItem.warnNum,
            isConfirm: selectedPriceItem.isConfirm,
            gapPrice: selectedPriceItem.gapPrice
          }
        }
      }
    }
  },
  methods: {
    checkMaxPrice(rule, value, callback) {
      if (Number(value) > 100000) {
        callback(new Error('请输入0-100000的数'))
      } else {
        callback()
      }
    },
    getMonthPriceInfo() {
      const params = {
        optionId: this.optionId,
        proId: this.proId,
        ratePlanId: 0,
        startDateStr: this.monthStr + '-01'
      }
      this.getHttpServices().getProService().post('bespeak/getBespeakfullMonthPrice', params)
        .then(detail => {
          this.priceForm = {
            ...this.priceForm,
            addAmountWay: detail.addAmountWay,
            priceMode: detail.priceMode,
            redeemCount: detail.redeemCount
          }
          this.priceDataList = detail.calendarDayVOs
          this.selectedDateList = []
          this.selectedAll = false
          this.getLogUtils().logWithTag('getMonthPriceInfo', detail)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListData(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.priceDataList.find((item, index, arr) => item.bespeakPriceDate === dateStr)
      if (priceItem) {
        if (priceItem.bespeakPrice) {
          listData.push({ type: 'success', content: '差价    ' + priceItem.bespeakPrice })
        }
        if (priceItem.stockNum) {
          listData.push({ type: 'success', content: '库存    ' + priceItem.stockNum })
        }
        if (priceItem.warnNum) {
          listData.push({ type: 'success', content: '预警值    ' + priceItem.warnNum })
        }
      }
      return listData
    },
    isSelected(momentValue) {
      const dateStr = this.getDateHelper().getFormatDate(momentValue)
      const index = this.selectedDateList.findIndex((item, index, arr) => dateStr === item)
      return index >= 0
    },
    //判断选项是否禁用(非当前月的数据禁用)
    isDisabledDate(value) {
      const dateStr = this.getDateHelper().formatDate(value, 'YYYY-MM')
      return dateStr !== this.monthStr
    },
    onTabClick(key) {
      const proId = this.getPageParams().proId
      this.$router.push({
        name: 'CouponCodeSetting',
        query: {
          type: key,
          proId: proId,
          couponType: this.couponType
        }
      })
    },
    onPanelChange(date, mode) {
      this.mode = mode
      this.getLogUtils().logWithTag('===onPanelChange mode===', mode)
      if (mode === 'month') {
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.selectedAll = false
        this.getMonthPriceInfo()
      }
    },
    onDateSelected(date) {
      this.getLogUtils().logWithTag('==onDateSelected mode===', this.mode)
      if (this.mode === 'year') {
        this.mode = 'month'
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getMonthPriceInfo()
      } else {
        const dateStr = this.getDateHelper().getFormatDate(date)
        this.getLogUtils().logWithTag('==onDateSelected dateStr===', dateStr)
        if (this.isSelected(date)) {
          this.selectedDateList = this.selectedDateList.filter((item, index, arr) => dateStr !== item)
        } else {
          this.selectedDateList.push(dateStr)
        }
      }
    },

    selectedAllDate: function(e) {
      if (e.target.checked) {
        const newList = []
        let days = this.getDateHelper().getDaysInMonth(this.monthStr + '-01')
        for (let i = 1; i <= days; i++) {
          newList.push(this.monthStr + '-' + (i > 9 ? i : '0' + i))
        }
        this.selectedDateList = newList
      } else {
        this.selectedDateList = []
      }
      this.selectedAll = e.target.checked
      this.getLogUtils().logWithTag('selectedAllDate', e.target.checked)
      this.getLogUtils().logWithTag('==selectedAllDate dateListStr===', this.selectedDateList)
    },
    saveEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.selectedDateList.length < 1) {
            this.$message.error('请选择日期')
            return
          }
          this.requestSave()
        }
      })
    },
    deleteEvent() {
      this.saveLoading = true
      let params = {
        optionId: this.optionId,
        optionProId: this.proId,
        bespeakPriceDate: this.selectedDateList.join(',')
      }
      this.getHttpServices().getProService().post('bespeak/delBespeakPrice', params)
        .then(res => {
          this.$message.success('价格信息删除成功')
          this.selectedDateList = []
          this.getMonthPriceInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },
    requestSave() {
      this.saveLoading = true
      let params = {
        optionId: this.optionId,
        productId: this.proId,
        bespeakPrice: this.priceForm.bespeakPrice,
        isConfirm: this.priceForm.isConfirm,
        stockNum: this.priceForm.stockNum,
        warnNum: this.priceForm.warnNum,
        gapPrice: this.priceForm.gapPrice,
        bespeakPriceDate: this.selectedDateList.join(',')
      }
      this.getHttpServices().getProService().post('bespeak/saveBespeakPrice', params)
        .then(res => {
          this.$message.success('价格信息保存成功')
          // setTimeout(() => this.backEvent(), 1000)
          this.getMonthPriceInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style lang="less">
.package-price-setting {
  .selected-color {
    background-color: #e6f7ff;
  }

  .ant-card-body {
    padding-top: 1px;
  }

  .item-checkbox {
    position: absolute;
    top: 6px;
  }

  .ant-fullcalendar table {
    height: 100px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 100px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 100px;
  }
}
</style>